import React, { forwardRef } from "react";
import EmailField from "@streeteasy/design-system/experimental/EmailField";
import { bool, shape, string } from "prop-types";
import uuid from "uuid/v4";

import { formikInjectedFieldPropTypes } from "../formikPropTypes";
import InputWrapper from "../InputWrapper";

const EmailInput = forwardRef(({ error, field, ...props }, ref) => (
  <InputWrapper>
    <EmailField
      ref={ref}
      error={error}
      hint={props.required ? "required" : ""}
      id={uuid()}
      isValid={!error}
      {...field}
      {...props}
    />
  </InputWrapper>
));

EmailInput.propTypes = {
  error: string,
  field: shape(formikInjectedFieldPropTypes),
  required: bool
};

EmailInput.defaultProps = {
  error: "",
  field: null,
  required: false
};

export default EmailInput;
